import {useEffect, useRef, useState} from "react"
import Text from "../../components/input/text";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {landing_domain, landing_info} from "../../config/tips";
import Select from "../../components/input/select";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import {Eye, Info, Settings} from "react-feather";

import TabLabel from "../../components/tabLabel";

import InputCode from "../../components/input/code";
import {Enums} from "../../config/Config";
import MobilePreview from "../../components/mobile-preview";

const Form = (props) => {
    const {landing, enterprises, domains, errors, isReady, onSubmit, onChangeEnterprise} = props

    const formRef = useRef()
    const [enterprise, setEnterprise] = useState()
    const [activeTab, setActiveTab] = useState('')
    const infoTab = <TabLabel slug="info" label="Info" icon={<Info/>} errors={errors}/>
    const previewTab = <TabLabel slug="preview" label="Preview" icon={<Eye/>} errors={errors}/>
    const settingsTab = <TabLabel slug="settings" label="Settings" icon={<Settings/>} errors={errors}/>



    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            info   : {
                name           : FormData.get('name'),
                status         : FormData.get('status'),
                id_enterprise  : FormData.get('id_enterprise')
            },
            settings: {
                id_domain      : FormData.get('id_domain'),
                subdomain      : FormData.get('subdomain'),
            },
            content: {
                html: FormData.get('html'),
            }
        })
    }


    const handleTabClick = (ev) => {
        setActiveTab(ev)
    }



    const handleEnterpriseChange = (ev) => {
        onChangeEnterprise(ev)
        setEnterprise(ev.value)
    }



    useEffect(() => {
        setEnterprise(landing?.id_enterprise?.$oid)
    }, [landing])




    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <Tabs defaultActiveKey="0" onTabClick={handleTabClick}>
                <TabPane forceRender={true} key={'info'} tabKey={'info'} tab={infoTab}>
                    <Alert
                        icon="info"
                        docsPath="/docs/landing"
                        message={landing_info}
                    />

                    <Text required
                        size="md"
                        name="name"
                        label="Name"
                        isReady={isReady}
                        error={errors && errors['info.name']}
                        value={landing?.name}
                        placeholder="Type landing name..."
                    />

                    <Select required
                        size="md"
                        isReady={isReady}
                        label="Enterprise"
                        name="id_enterprise"
                        options={enterprises}
                        value={enterprise}
                        error={errors && errors['info.id_enterprise']}
                        placeholder="Choose an enterprise"
                        onChange={handleEnterpriseChange}
                    />


                    <Select required
                        size="md"
                        isReady={isReady}
                        label="Status"
                        name="status"
                        options={Enums.status.landing}
                        value={landing?.status}
                        error={errors && errors['info.id_enterprise']}
                        placeholder="Choose status"
                    />

                    <InputCode required
                        size="md"
                        name="html"
                        label="Html content"
                        isReady={isReady}
                        error={errors && errors['content.html']}
                        value={landing?.content}
                        placeholder="Type html version..."
                    />
                </TabPane>
                {(landing || domains?.length > 0) && <>
                    <TabPane forceRender={true} key={'settings'} tabKey={'settings'} tab={settingsTab}>
                        <Alert
                            icon="info"
                            docsPath="/docs/landing"
                            message={landing_domain}
                        />

                        {landing && <Text
                            required
                            size="md"
                            name="subdomain"
                            label="Subdomain"
                            isReady={isReady}
                            suffix=".idnurt.com"
                            error={errors && errors['settings.subdomain']}
                            placeholder="Type subdomain..."
                            value={landing?.subdomain}
                        />}


                        {domains?.length > 0 && <Select
                            size="md"
                            label="Domain"
                            name="id_domain"
                            options={domains}
                            isReady={isReady}
                            isClearable={true}
                            value={landing?.id_domain?.$oid}
                            error={errors && errors['settings.id_domain']}
                            placeholder="Choose a domain"
                        />}

                    </TabPane>
                    {landing && <TabPane forceRender={false} key={'preview'} tabKey={'preview'} tab={previewTab}>
                        <MobilePreview scroll title={landing?.name} url={landing.permalink}/>
                    </TabPane>}

                </>}
            </Tabs>

            {activeTab !== "preview" && <Button
                size="sm"
                color="primary"
                isReady={isReady}
                icon={landing ? 'check' : 'plus'}
                label={landing ? 'Update' : 'Create'}
            />}

        </form>
    )
}

export default Form